import { FirebaseService } from "../Services/firebaseService";

export class lostPasswordPage
{
    emailElement : HTMLButtonElement = document.getElementById('email') as HTMLButtonElement;
    submitElement: HTMLInputElement = document.getElementById('submitbutton') as HTMLInputElement;

    firebaseService:FirebaseService
    constructor()
    {
        console.log('lost')
        this.firebaseService = new FirebaseService();
        this.init();
    }

    async init()
    {
        this.submitElement.addEventListener('click', async (event:any) => {
            event.preventDefault();
            event.stopPropagation();
            await this.firebaseService.lostPassword(this.emailElement.value);
            document.location.href = "/connexion";
        })
    }
}